import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { IDocumentType } from '../../../../state/documenttype.repository';
import { DocumentTypesService } from '../../../../state/documenttype.service';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';

@Component({
    selector: 'app-documenttype-post',
    templateUrl: './documenttype-post.component.html',
    styleUrls: ['./documenttype-post.component.scss'],
    standalone: false
})
export class DocumenttypePostComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    public genData: GeneralDataRepository,
    private service: DocumentTypesService,
    private location: Location
  ) {}
  editForm: UntypedFormBuilder | any;
  @Input() editedPost: Partial<IDocumentType> | null = null;
  submitErrors: string[] | null = null;

  ngOnInit(): void {
    this.editForm = this.formBuilder.group({
      name: [this.editedPost?.name, Validators.required],
      isShownOnSideMenu: [this.editedPost?.isShownOnSideMenu],
    });
  }

  onSubmit() {
    if (!this.editForm?.valid) {
      this.editForm.markAllAsTouched();
      return;
    }

    const name = this.editForm.value?.name.toString();
    const isShownOnSideMenu = this.editForm.value?.isShownOnSideMenu;
    this.submitErrors = null;

    this.service.postDocumentType({ name, isShownOnSideMenu }).subscribe({
      next: (res: IDocumentType) => {
        if (res) {
          res.isShownOnSideMenu = isShownOnSideMenu;
        }
        this.genData.updateAllGeneralData(true);
        this.location.back();
      },
      error: (err) => {
        this.submitErrors = err.error?.message;
      },
    });
  }
}
